import apiClient from './apiClient'

export interface ConfigEntry {
  id: number
  key: string
  value: string
  description: string
  updatedAt: string
}

export const CONFIG_KEYS = {
  // SharePoint — fallback složky podle stavu
  SharePointUrl_EmployeeActive:     'SharePointUrl_EmployeeActive',
  SharePointUrl_EmployeeTerminated: 'SharePointUrl_EmployeeTerminated',
  SharePointUrl_ContractorActive:   'SharePointUrl_ContractorActive',
  SharePointUrl_ContractorInactive: 'SharePointUrl_ContractorInactive',
  // zachováno pro zpětnou kompatibilitu (starý fallback)
  SharePointDefaultUrl: 'SharePointDefaultUrl',
  // Dovolená
  VacationDaysDefault: 'VacationDaysDefault',
  // HR manažeři
  HrManagerEmail1: 'HrManagerEmail1',
  HrManagerEmail2: 'HrManagerEmail2',
  HrManagerEmail3: 'HrManagerEmail3',
  // Zdravotní pojišťovny
  HealthInsurances: 'HealthInsurances',
  // E-mailové šablony dokumentů
  EmailTemplate_SignatureReminder_Subject:      'EmailTemplate_SignatureReminder_Subject',
  EmailTemplate_SignatureReminder_Body:         'EmailTemplate_SignatureReminder_Body',
  EmailTemplate_AcquaintanceReminder_Subject:   'EmailTemplate_AcquaintanceReminder_Subject',
  EmailTemplate_AcquaintanceReminder_Body:      'EmailTemplate_AcquaintanceReminder_Body',
  EmailTemplate_SignatureNotification_Subject:  'EmailTemplate_SignatureNotification_Subject',
  EmailTemplate_SignatureNotification_Body:     'EmailTemplate_SignatureNotification_Body',
  EmailTemplate_AcquaintanceNotification_Subject: 'EmailTemplate_AcquaintanceNotification_Subject',
  EmailTemplate_AcquaintanceNotification_Body:    'EmailTemplate_AcquaintanceNotification_Body',
  EmailTemplate_LmsReminder_Subject:        'EmailTemplate_LmsReminder_Subject',
  EmailTemplate_LmsReminder_Body:           'EmailTemplate_LmsReminder_Body',
  EmailTemplate_LmsNotification_Subject:    'EmailTemplate_LmsNotification_Subject',
  EmailTemplate_LmsNotification_Body:       'EmailTemplate_LmsNotification_Body',
} as const

export const configService = {
  getAll: () =>
    apiClient.get<ConfigEntry[]>('/config').then((r: { data: ConfigEntry[] }) => r.data),

  getByKey: (key: string) =>
    apiClient.get<ConfigEntry>(`/config/${key}`).then((r: { data: ConfigEntry }) => r.data),

  upsert: (key: string, value: string, description?: string) =>
    apiClient.put<ConfigEntry>(`/config/${key}`, { value, description }).then((r: { data: ConfigEntry }) => r.data),
}
